import { render, staticRenderFns } from "./Ticks.vue?vue&type=template&id=24f4dfec&"
import script from "./Ticks.vue?vue&type=script&lang=js&"
export * from "./Ticks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports